import {
  REQUEST_GET_UBER_EATS_USERS_BY_GAME_WEEK,
  SUCCESS_GET_UBER_EATS_USERS_BY_GAME_WEEK,
  FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK,
} from '../../../actions/entities/uberEats';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  return {
    ...state,
    data: action.list,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_UBER_EATS_USERS_BY_GAME_WEEK]: requestFetch,
  [SUCCESS_GET_UBER_EATS_USERS_BY_GAME_WEEK]: successFetch,
  [FAIL_GET_UBER_EATS_USERS_BY_GAME_WEEK]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/uberEats/gameWeek.js